import { useObservable } from "react-use-observable";
import { pluck } from "rxjs";

import { ISubtitle } from "../interfaces/watch";
import { watchService } from "../services/watch";

export const useSubtitles = () => {
  const [subtitles] = useObservable<ISubtitle[] | undefined>(
    () => watchService.getWatchInfo().pipe(pluck("subtitles")),
    []
  );

  return subtitles;
};
